import VaultInput from "shared-components/vault-input";
import { STATES } from "../const";
import { SnapSelectMenu } from "suit";
import React, { useEffect, useState } from "react";

type AddressProps = {
  entityPrefix: string;
  onStateSelect: (state: string) => void;
  onValid: React.ComponentProps<typeof VaultInput>["onValid"];
};

export default function Address({
  entityPrefix,
  onStateSelect,
  onValid,
}: AddressProps) {
  const [streetIsValid, setStreetIsValid] = useState(false);
  const [cityIsValid, setCityIsValid] = useState(false);
  const [zipIsValid, setZipIsValid] = useState(false);
  const addressIsValid = streetIsValid && cityIsValid && zipIsValid;
  useEffect(() => {
    if (onValid) {
      onValid(addressIsValid);
    }
  }, [addressIsValid, onValid]);

  return (
    <>
      <div className="lg:grid grid-cols-2 lg:gap-6 flex flex-col lg:mt-4">
        <div className="w-full">
          <VaultInput
            name={`${entityPrefix}Street`}
            type="text"
            label="Street"
            placeholder="Street"
            onValid={setStreetIsValid}
            required={true}
          />
        </div>
        <div className="w-full">
          <VaultInput
            name={`${entityPrefix}Unit`}
            type="text"
            placeholder="Unit"
            label="Unit"
          />
        </div>
      </div>
      <div className="lg:grid grid-cols-3 lg:gap-6 flex flex-col lg:mt-4">
        <div className="w-full">
          <VaultInput
            name={`${entityPrefix}City`}
            type="text"
            placeholder="City"
            label="City"
            onValid={setCityIsValid}
            required={true}
          />
        </div>
        <div className="w-full">
          <SnapSelectMenu
            placeholder="State"
            label="State"
            selectMenuOptions={STATES}
            onSnap-select-menu-updated={(e) => {
              const selected = e.detail.find((option) => option.selected);
              if (selected?.value) {
                onStateSelect(selected.value);
              }
            }}
          />
        </div>
        <div className="w-full">
          <VaultInput
            name={`${entityPrefix}Zip`}
            type="zip"
            placeholder="Zip Code"
            label="Zip Code"
            onValid={setZipIsValid}
            required={true}
          />
        </div>
      </div>
    </>
  );
}
